import {gql, useMutation} from '@apollo/client';

const REGISTER_USER_DATA = gql`
    mutation RegisterUser($email: String, $password: String) {
      registerUser(email: $email, password: $password) {
        email
        id
        token
      }
    }
`;

export const useRegisterUser = () => {
    const [executeMutation, { data, loading, error }] = useMutation(REGISTER_USER_DATA);

    const registerUser = (email: string, password: string) => {
        return executeMutation({ variables: { email, password }, errorPolicy: 'all' });
    };

    return { registerUser, data, loading, error };
};

